import _typeof from "@babel/runtime/helpers/typeof";
import * as React from 'react';
import { useMonth } from '@datepicker-react/hooks';
import { IconChevronLeft, IconChevronRight } from '../../../icons';
import { Button, Buttons } from '../../button';
import { DatePickerContext } from './context';
import { datePickerClasses } from './date-picker';
import { Day } from './day';
export var Month = function Month(props) {
  var _React$useContext = React.useContext(DatePickerContext),
    goToNextMonths = _React$useContext.goToNextMonths,
    goToPreviousMonths = _React$useContext.goToPreviousMonths;
  var _useMonth = useMonth({
      year: props.month.year,
      month: props.month.month,
      firstDayOfWeek: props.firstDayOfWeek
    }),
    days = _useMonth.days,
    weekdayLabels = _useMonth.weekdayLabels,
    monthLabel = _useMonth.monthLabel;
  return React.createElement("div", {
    className: datePickerClasses.MONTH
  }, React.createElement("div", {
    className: datePickerClasses.MONTH_HEADER
  }, React.createElement("div", {
    className: datePickerClasses.MONTH_LABEL
  }, " ", monthLabel, " "), React.createElement(Buttons, {
    className: "month-selectors",
    size: "small",
    appearance: "minimal",
    density: "compact",
    isSquare: true
  }, React.createElement(Button, {
    className: "month-arrow",
    children: React.createElement(IconChevronLeft, null),
    onClick: goToPreviousMonths
  }), React.createElement(Button, {
    className: "month-arrow",
    children: React.createElement(IconChevronRight, null),
    onClick: goToNextMonths
  }))), React.createElement("div", {
    className: "labels grid"
  }, weekdayLabels.map(function (dayLabel) {
    return React.createElement("div", {
      key: dayLabel
    }, dayLabel);
  })), React.createElement("div", {
    className: "grid"
  }, days.map(function (day, index) {
    if (_typeof(day) === 'object') {
      return React.createElement(Day, {
        date: day.date,
        key: day.date.toString(),
        label: day.dayLabel
      });
    }
    return React.createElement("div", {
      key: index
    });
  })));
};